import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "navbar navbar-expand-md ms-lg-4 me-lg-4 pt-2",
  style: {"color":"var(--light-slate)","background":"var(--nevy)"}
}
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = {
  class: "navbar-brand",
  href: "#"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  class: "collapse navbar-collapse links",
  id: "navbarNav"
}
const _hoisted_6 = {
  key: 0,
  class: "navbar-nav ms-auto mb-2 mb-lg-0 gap-3"
}
const _hoisted_7 = { class: "nav-item d-inline-block" }

import logo from "@/assets/logo.svg"
import {onBeforeUnmount, onMounted, ref} from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'header-menu',
  setup(__props) {

const showFooter = ref(false);
const showHeader = ref(true);
const disableBoxShadow = ref(true);
const lastScrollPosition = ref(0);
const scrollOffset = ref(40);
onMounted(() => {
    lastScrollPosition.value = window.pageYOffset;
    window.addEventListener('scroll', onScroll)

    setTimeout(() => {
        showFooter.value = true;
    }, 500)
})
onBeforeUnmount(() => {
    window.removeEventListener('scroll', onScroll)

})

function onScroll() {
    if (window.pageYOffset < 0) {
        return;
    }
    if (Math.abs(window.pageYOffset - lastScrollPosition.value) < scrollOffset.value) {
        return;
    }
    disableBoxShadow.value = window.pageYOffset < 40;

    showHeader.value = window.pageYOffset < lastScrollPosition.value;
    lastScrollPosition.value = window.pageYOffset;

}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", [{ 'is-hidden': !showHeader.value },{'fixed-top':showHeader.value},{'box-shadow-none':disableBoxShadow.value},{'box-shadow-show':!disableBoxShadow.value}]])
  }, [
    _createElementVNode("nav", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_TransitionGroup, {
          name: "fade",
          appear: ""
        }, {
          default: _withCtx(() => [
            (showHeader.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("a", _hoisted_3, [
                    _createElementVNode("img", {
                      src: _unref(logo),
                      alt: "",
                      width: "40",
                      height: "40"
                    }, null, 8, _hoisted_4)
                  ]),
                  _cache[0] || (_cache[0] = _createElementVNode("button", {
                    class: "navbar-toggler",
                    type: "button",
                    "data-toggle": "collapse",
                    "data-target": "#navbarNav",
                    "aria-controls": "navbarNav",
                    "aria-expanded": "false",
                    "aria-label": "Toggle navigation"
                  }, [
                    _createElementVNode("span", { class: "navbar-toggler-icon" })
                  ], -1))
                ], 64))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_TransitionGroup, {
            name: "list",
            appear: ""
          }, {
            default: _withCtx(() => [
              (showFooter.value)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_6, [
                    _cache[2] || (_cache[2] = _createElementVNode("li", { class: "nav-item" }, [
                      _createElementVNode("span", { class: "font-fira-code text-info" }, "01. "),
                      _createElementVNode("a", {
                        class: "nav-link d-inline-block",
                        "aria-current": "page",
                        href: "/#about"
                      }, "About")
                    ], -1)),
                    _cache[3] || (_cache[3] = _createElementVNode("li", { class: "nav-item" }, [
                      _createElementVNode("span", { class: "font-fira-code text-info" }, "02. "),
                      _createElementVNode("a", {
                        class: "nav-link d-inline-block",
                        href: "/#experience"
                      }, "Experience")
                    ], -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("li", { class: "nav-item" }, [
                      _createElementVNode("span", { class: "font-fira-code text-info" }, "03. "),
                      _createElementVNode("a", {
                        class: "nav-link d-inline-block",
                        href: "/#works"
                      }, " Work ")
                    ], -1)),
                    _cache[5] || (_cache[5] = _createElementVNode("li", { class: "nav-item" }, [
                      _createElementVNode("span", { class: "font-fira-code text-info" }, "04. "),
                      _createElementVNode("a", {
                        class: "nav-link d-inline-block",
                        href: "/#contact"
                      }, "Contact ")
                    ], -1)),
                    _createElementVNode("li", _hoisted_7, [
                      _createVNode(_component_router_link, {
                        class: "nav-link text-info font-fira-code",
                        style: {"border":"1px solid var(--green)","border-radius":"3px"},
                        target: "_blank",
                        to: '/HosseinShakeriResume.pdf'
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("Resume ", -1)
                        ]))]),
                        _: 1
                      })
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}
}

})